import React from 'react';
import './App.css';
import Stages from './components/Stages';

function App() {
  return (
    <div className="App">
      <main>
        <h2>List Making</h2>
        <Stages />
      </main>
    </div>
  );
}

export default App;
